import {site} from "../context/context";
import {Event, IEvent} from "./event";
import {log} from "../util/log";

class AnalyticManager {
    /* STATIC */

    /* INSTANCE */
    public register(event: IEvent): void {
        log.debug(`Intentando lanzar evento ${event.action} - ${event.label}...`)
        const config = site.analyticConfig();
        if (config && config.e && config.p) {
            Event.create(event).register(config.p);
            Event.createTest(event)?.register(config.p);
        } else {
            log.debug(`No se ha podido lanzar el evento ${event.action} - ${event.label} porque no se ha encontrado la configuración de analytics`);
        }
    }
}

let instance: AnalyticManager|null = null;
export default ()=>{
    return instance ??= new AnalyticManager();
}
